
import * as handlebars_family from "../handlebars_family.ts";
import "../widget/form/checkbox.ts";
import "../widget/form/required.ts";
const TPL = handlebars_family.addTemplate("nc/terms_para",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p style=\"display:flex;flex-direction:rows;align-items: center;\"><span style=\"padding-right:8px\"><span style=\"position:relative\" data-widget=\"widget/form/checkbox\"><input type=\"checkbox\" name=\"terms\" value=\"true\" style=\"display:none\" data-widget=\"widget/form/required\" data-fw-form-required-error=\"nc.fields.termsprivacyrequired\" /><icon style=\"color:#D9D9D9;vertical-align: middle;\"></icon></span></span><span style=\"font-size:15px\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.termsprivacy",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":435},"end":{"line":1,"column":470}}})) != null ? stack1 : "")
    + " </span></p> ";
},"useData":true});
export default TPL;